import { useState, useEffect } from "react";
import LoaderWithBackdrop from "../../loader/LoaderWithBackdrop";

function FiveImagesPreview({
  imagesList,
  maxHeight,
  checkImagesWiderThanTall,
  imageTag,
  handleOpenDetails = () => {},
}) {
  const [widerImage, setWiderImage] = useState(null);

  useEffect(() => {
    const checkImages = async () => {
      const result = await checkImagesWiderThanTall(1);
      setWiderImage(result);
    };

    checkImages();
  }, [imagesList]);

  // Helper function to generate common styles
  const getImageStyle = (
    heightDivide,
    heightSub,
    width,
    padding = false,
    borderRadius = {}
  ) => ({
    height: `calc((${maxHeight} / ${heightDivide}) - ${heightSub}px)`,
    width: width ? `calc(${width} - 1px)` : "",
    borderTopLeftRadius: borderRadius.topLeft || "inherit",
    borderTopRightRadius: borderRadius.topRight || "inherit",
    borderBottomLeftRadius: borderRadius.bottomLeft || "inherit",
    borderBottomRightRadius: borderRadius.bottomRight || "inherit",
    padding: padding ? "2px" : "",
  });

  if (widerImage === null) {
    return (
      <div style={{ position: "relative", height: `calc(${maxHeight} / 2)` }}>
        <LoaderWithBackdrop isAbsolute={true} />
      </div>
    );
  }

  return (
    <div className="row m-0" style={{ borderRadius: "inherit", maxHeight }}>
      {widerImage ? (
        <>
          <div
            className="col-12 px-0 d-flex justify-content-between"
            style={getImageStyle(2, 4, null, true, {
              topLeft: "inherit",
              topRight: "inherit",
              bottomLeft: "0",
              bottomRight: "0",
            })}
          >
            <div
              style={getImageStyle(2, 8, "50%", false, {
                topLeft: "inherit",
                topRight: "0",
                bottomLeft: "0",
                bottomRight: "0",
              })}
            >
              {imageTag(imagesList[0], 0)}
            </div>
            <div
              style={getImageStyle(2, 8, "50%", false, {
                topLeft: "0",
                topRight: "inherit",
                bottomLeft: "0",
                bottomRight: "0",
              })}
            >
              {imageTag(imagesList[1], 1)}
            </div>
          </div>

          <div
            className="col-12 px-0 d-flex justify-content-between pt-0"
            style={getImageStyle(2, 6, null, true, {
              topLeft: "0",
              topRight: "0",
              bottomLeft: "inherit",
              bottomRight: "inherit",
            })}
          >
            <div
              style={getImageStyle(2, 8, "33%", false, {
                topLeft: "0",
                topRight: "0",
                bottomLeft: "inherit",
                bottomRight: "0",
              })}
            >
              {imageTag(imagesList[2], 2)}
            </div>
            <div
              style={getImageStyle(2, 8, "34%", false, {
                topLeft: "0",
                topRight: "0",
                bottomLeft: "0",
                bottomRight: "0",
              })}
            >
              {imageTag(imagesList[3], 3)}
            </div>
            <div
              style={getImageStyle(2, 8, "33%", false, {
                topLeft: "0",
                topRight: "0",
                bottomLeft: "0",
                bottomRight: "inherit",
              })}
              className="position-relative"
            >
              {imageTag(imagesList[4], imagesList.length == 5 ? 4 : 0)}
              {imagesList.length > 5 && (
                <div
                  onClick={() => handleOpenDetails()}
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    color: "white",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "20px",
                    fontWeight: "bold",
                    cursor: "pointer",
                    borderBottomRightRadius: "inherit",
                  }}
                >
                  +{imagesList.length - 5}
                </div>
              )}
            </div>
          </div>
        </>
      ) : (
        <>
          <div
            className="col-6  d-flex flex-column justify-content-between"
            style={getImageStyle(1, 4, null, true, {
              topLeft: "inherit",
              topRight: "0",
              bottomLeft: "inherit",
              bottomRight: "0",
            })}
          >
            <div
              style={getImageStyle(2, 6, null, false, {
                topLeft: "inherit",
                topRight: "0",
                bottomLeft: "0",
                bottomRight: "0",
              })}
            >
              {imageTag(imagesList[0], 0)}
            </div>
            <div
              style={getImageStyle(2, 6, null, false, {
                topLeft: "0",
                topRight: "0",
                bottomLeft: "inherit",
                bottomRight: "0",
              })}
            >
              {imageTag(imagesList[1], 1)}
            </div>
          </div>

          <div
            className="col-6  d-flex flex-column justify-content-between"
            style={getImageStyle(1, 4, null, true, {
              topLeft: "0",
              topRight: "inherit",
              bottomLeft: "0",
              bottomRight: "inherit",
            })}
          >
            <div
              style={getImageStyle(3, 5, null, false, {
                topLeft: "0",
                topRight: "inherit",
                bottomLeft: "0",
                bottomRight: "0",
              })}
            >
              {imageTag(imagesList[2], 2)}
            </div>
            <div
              style={getImageStyle(3, 5, null, false, {
                topLeft: "0",
                topRight: "0",
                bottomLeft: "0",
                bottomRight: "0",
              })}
            >
              {imageTag(imagesList[3], 3)}
            </div>
            <div
              style={getImageStyle(3, 5, null, false, {
                topLeft: "0",
                topRight: "0",
                bottomLeft: "0",
                bottomRight: "inherit",
              })}
              className="position-relative"
            >
              {imageTag(imagesList[4], imagesList.length == 5 ? 4 : 0)}
              {imagesList.length > 5 && (
                <div
                  onClick={() => handleOpenDetails()}
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    color: "white",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "20px",
                    fontWeight: "bold",
                    cursor: "pointer",
                    borderBottomRightRadius: "inherit",
                  }}
                >
                  +{imagesList.length - 5}
                </div>
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default FiveImagesPreview;
